import React, { useState } from 'react';
import { authAPI } from '../api/client';
import { apiError } from '../lib/host';
import './Layout.css';

const EMPTY = { current: '', next: '', confirm: '' };

/** Change password while signed in; other devices are signed out, this one stays. */
export default function PasswordCard() {
  const [form, setForm] = useState(EMPTY);
  const [msg, setMsg] = useState({ type: '', text: '' });
  const [busy, setBusy] = useState(false);

  const set = (e) => { setForm({ ...form, [e.target.name]: e.target.value }); setMsg({ type: '', text: '' }); };

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 6) return setMsg({ type: 'error', text: 'New password must be at least 6 characters' });
    if (form.next !== form.confirm) return setMsg({ type: 'error', text: "New passwords don't match" });
    setBusy(true);
    try {
      const res = await authAPI.changePassword(form.current, form.next);
      const n = res.data.other_sessions_ended;
      setForm(EMPTY);
      setMsg({ type: 'ok', text: `Password changed.${n ? ` Signed out ${n} other device${n > 1 ? 's' : ''}.` : ''}` });
    } catch (err) {
      setMsg({ type: 'error', text: apiError(err, 'Could not change the password') });
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="tcx-panel">
      <h3>Password</h3>
      {msg.text && <div className={msg.type === 'ok' ? 'tcx-success' : 'admin-error'}>{msg.text}</div>}
      <form className="tcx-row" onSubmit={submit}>
        <div className="form-group">
          <label htmlFor="pw-current">Current password</label>
          <input id="pw-current" name="current" type="password" className="tcx-input" required autoComplete="current-password"
            value={form.current} onChange={set} />
        </div>
        <div className="form-group">
          <label htmlFor="pw-next">New password</label>
          <input id="pw-next" name="next" type="password" className="tcx-input" required minLength={6} autoComplete="new-password"
            value={form.next} onChange={set} />
        </div>
        <div className="form-group">
          <label htmlFor="pw-confirm">Confirm new password</label>
          <input id="pw-confirm" name="confirm" type="password" className="tcx-input" required autoComplete="new-password"
            value={form.confirm} onChange={set} />
        </div>
        <button className="tcx-btn" disabled={busy}>{busy ? 'Saving...' : 'Change password'}</button>
      </form>
    </section>
  );
}
